import React from 'react';
import { ArrowUpRightIcon, Building2Icon, HomeIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { StarRating } from './StarRating';
import { useLanguage } from '../contexts/LanguageContext';
import { business } from '../data/business';
import { testimonials } from '../data/testimonials';
import { ui } from '../data/ui';
export function Testimonials() {
  const {
    t
  } = useLanguage();
  return <section id="testimonials" className="section-y bg-mist" aria-labelledby="testimonials-title" data-id="element-353" data-mp="370k9wf4xurlt">
      <div className="container-page" data-id="element-354" data-mp="31ybgxis2fpjp">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between" data-id="element-355" data-mp="2x0tbw3h65ugz">
          <SectionHeading id="testimonials-title" title={t(ui.testimonials.title)} subtitle={t(ui.testimonials.subtitle)} align="left" data-id="element-356" data-mp="2s1q8engu7wb4" />
          <a href={business.mapsUrl} target="_blank" rel="noopener noreferrer" className="inline-flex shrink-0 items-center gap-3 self-start rounded-lg bg-white px-4 py-3 text-sm text-ink shadow-sm ring-1 ring-line transition-colors duration-150 hover:ring-navy/40 md:self-auto" data-id="element-357" data-mp="v9om7cysr3za">
            <StarRating data-id="element-358" data-mp="m6cedq2u0ayh" />
            <span data-id="element-359" data-mp="77s8q2mgih1e">
              <strong className="font-semibold" data-id="element-360" data-mp="78a9nck2djfn">{business.rating.toFixed(1)}</strong> {t(ui.onGoogle)}
            </span>
            <ArrowUpRightIcon className="h-4 w-4 text-muted" aria-hidden="true" data-id="element-361" data-mp="c7wry0er1pvb" />
          </a>
        </div>

        <ul className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-6" data-id="element-362" data-mp="zxr3menc18dz">
          {testimonials.map((item, i) => {
          const MarketIcon = item.market === 'commercial' ? Building2Icon : HomeIcon;
          return <li key={item.name} className={i < 2 ? 'lg:col-span-3' : 'lg:col-span-2'} data-id="element-363" data-mp="q4jv4kxapc9o" data-mpi={i}>
                <figure className="flex h-full flex-col rounded-2xl bg-white p-7 shadow-sm ring-1 ring-line" data-id="element-364" data-mp="v3wh73gcefb7">
                  <div className="flex items-center justify-between gap-3" data-id="element-365" data-mp="1ith3nwbpfup8">
                    <StarRating data-id="element-366" data-mp="1nnlewrs06ow4" />
                    <span className="inline-flex items-center gap-1.5 rounded-md bg-mist px-2 py-1 text-xs font-semibold text-navy" data-id="element-367" data-mp="1xi0mj81kxrxl">
                      <MarketIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-368" data-mp="1sinywl2vwgty" />
                      {item.market === 'commercial' ? t(ui.commercial) : t(ui.residential)}
                    </span>
                  </div>
                  <blockquote className={`mt-4 leading-relaxed text-ink ${i < 2 ? 'text-lg' : ''}`} data-id="element-369" data-mp="1jhpw2646mfcy">“{t(item.quote)}”</blockquote>
                  <figcaption className="mt-auto flex items-center gap-3 border-t border-line pt-5" data-id="element-370" data-mp="1ekzhjn80zrtn">
                    <Initials name={item.name} data-id="element-371" data-mp="19qlfx32rsogj" />
                    <div data-id="element-372" data-mp="14ud6857cdngr">
                      <p className="font-semibold text-ink" data-id="element-373" data-mp="14tlbsxphdvs2">{item.name}</p>
                      <p className="text-sm text-muted" data-id="element-374" data-mp="10srq8azigt2c">
                        {t(item.role)}
                        {item.company ? `, ${item.company}` : ''} · {item.city}
                      </p>
                    </div>
                  </figcaption>
                </figure>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}
function Initials({
  name
}: {
  name: string;
}) {
  const initials = name.replace(/^(Dr\.|Pastor)\s/, '').split(' ').map(p => p[0]).slice(0, 2).join('');
  return <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-navy font-display text-sm font-bold text-white" aria-hidden="true" data-id="element-375" data-mp="3ggoqxziqi8f4">
      {initials}
    </span>;
}